export default "__VITE_ASSET__ndjCueMG__"